/** CSGTorus3D's solid, exposed to the boolean evaluator. */
import { primitiveSolid } from '../../../../r3f/csg/csgRegistration';
import { buildCsgTorusGeometry } from './torusGeometry';
export const csgTorus3DGeometry = (properties) => {
    const p = properties;
    return primitiveSolid(buildCsgTorusGeometry({
        innerRadius: p.innerRadius,
        outerRadius: p.outerRadius,
        sides: p.sides,
        ringSides: p.ringSides,
        smoothFaces: p.smoothFaces,
        flipFaces: p.flipFaces,
    }), p);
};
export function csgTorus3DGeometryKey(properties) {
    const p = properties;
    return `tor:${p.innerRadius},${p.outerRadius},${p.sides},${p.ringSides},${p.smoothFaces},${p.flipFaces}`;
}
//# sourceMappingURL=csgGeometry.js.map